/**
 * This file contains the shared library between angularjs application
 */
import "./commons/shared-vendors";
import "./commons/modules/analytics";
